import type { ErrorResponseType } from './types';

export const ErrorResponses: Record<string, ErrorResponseType> = {
  NotAuthorizedException: {
    tone: 'critical',
    description: 'Incorrect username or password.',
  },

  UsernameAlreadyTaken: {
    tone: 'critical',
    description:
      'An account with this email already exists. Use another email or sign in instead.',
  },

  UserNotFoundException: {
    tone: 'critical',
    description:
      'Account is pending verification. Please verify your account or ask your administrator to re-invite you to the application',
  },
  InvalidPasswordException: {
    tone: 'critical',
    description:
      'Invalid password. Require minimum 8 characters, one upper case, one number and one special character',
  },
  UserNotConfirmedException: {
    tone: 'critical',
    description: 'User is not verified.',
  },
  UserMigrationNotFound: {
    tone: 'cautious',
    description:
      'The email address or username you entered is not known to Reckon. Please try again.',
  },
  LimitExceededException: {
    tone: 'critical',
    description: 'Attempt limit exceeded, please try after some time.',
    disabled: true,
  },
  TooManyFailedAttemptsException: {
    tone: 'critical',
    description: 'Attempt limit exceeded, please try after some time.',
    disabled: true,
  },
  TooManyRequestsException: {
    tone: 'critical',
    description: 'Attempt limit exceeded, please try after some time.',
    disabled: true,
  },
  CodeMismatchException: {
    tone: 'cautious',
    description:
      'Provided recovery code is invalid. Please try again or request a new code.',
  },
  ExpiredCodeException: {
    tone: 'critical',
    description:
      'Provided recovery code has expired. Please request a new code.',
  },
  InvalidParameterException: {
    tone: 'critical',
    description: 'Invalid parameters.',
  },
  UserLambdaValidationException: {
    tone: 'critical',
    description:
      'Something went wrong. Error 1011. Please try after some time.',
  },
  InternalErrorException: {
    tone: 'critical',
    description:
      'Something went wrong. Error 1012. Please try after some time.',
  },
  InvalidLambdaResponseException: {
    tone: 'critical',
    description:
      'Something went wrong. Error 1013. Please try after some time.',
  },
  UnexpectedLambdaException: {
    tone: 'critical',
    description:
      'Something went wrong. Error 1014. Please try after some time.',
  },
  ResourceNotFoundException: {
    tone: 'critical',
    description:
      'Something went wrong. Error 1015. Please try after some time.',
  },
  Unknown: {
    tone: 'critical',
    description: 'Something went wrong. Please try after some time.',
  },
};
export const ErrorResponseCodes = Object.keys(ErrorResponses);

export type ErrorResponse = typeof ErrorResponses[keyof typeof ErrorResponses];
